'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isExpression = (value) => {
    return typeof (value) === 'object' && value.name !== undefined && value.name.length > 0;
};
const expressionArgParser = (arg) => {
    switch (arg.dtype) {
        case 'num':
            return arg.num;
        case 'str':
            return arg.str;
        case 'exp':
            return arg.exp;
        default:
            return arg.str;
    }
};

exports.expressionArgParser = expressionArgParser;
exports.isExpression = isExpression;
//# sourceMappingURL=expression.js.map
